import React from 'react';
import './TabsSection.css';

const TabsSection = ({ activeTab, setActiveTab }) => {

  return (
    <div className="tabs-section">
      <div className="tabs-container">
        <div className="tabs-left">
          <button 
            className={`tab ${activeTab === 'Live' ? 'active' : ''}`}
            onClick={() => setActiveTab('Live')}
          >
            Live
            <span className="tab-badge green">8</span>
          </button>
          
          <button 
            className={`tab ${activeTab === 'Upcoming' ? 'active' : ''}`}
            onClick={() => setActiveTab('Upcoming')}
          >
            Upcoming
            <span className="tab-badge orange">5</span>
          </button>
          
          <button 
            className={`tab ${activeTab === 'Ended' ? 'active' : ''}`}
            onClick={() => setActiveTab('Ended')}
          >
            Ended
            <span className="tab-badge gray">225</span>
          </button>
        </div>
        
        <div className="tabs-right">
          <div className="search-box">
            <div className="search-icon">🔍</div>
            <input 
              type="text" 
              placeholder="Search" 
              className="search-input"
            />
          </div>
          
          <div className="network-filter">
            <select className="network-select">
              <option>🌐 All Networks</option>
              <option>Ethereum</option>
              <option>Arbitrum</option>
              <option>Polygon</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabsSection;
